import { render } from "./Commissions.vue?vue&type=template&id=6b3f98ff&scoped=true"
import script from "./Commissions.vue?vue&type=script&lang=js"
export * from "./Commissions.vue?vue&type=script&lang=js"

import "./custom-commissions.scss?vue&type=style&index=0&id=6b3f98ff&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3f98ff"]])

export default __exports__